export const GET_CART_ITEMS = "cart/items/get";

export const ADD_ITEM_TO_CART = "cart/items/add";

export const UPDATE_CART_ITEMS = "cart/items/update";

export const REMOVE_CART_ITEMS = "cart/items/remove";

export const UPDATE_QUANTITY = "cart/items/quantity";

